import 'parse';
const parse: typeof Parse = require('parse');
import { Component, OnInit } from '@angular/core';
import { Moment } from 'moment';
import { Device } from '../../model/search';
import { SearchService } from '../../service/search.service';
import { ToastService } from '../../service/toast.service';
import { AngularCsv } from 'angular-csv-ext/dist/Angular-csv';
import { I18n } from '@ngx-translate/i18n-polyfill';

@Component({
  selector: 'app-export-kpi',
  templateUrl: './export-kpi.component.html',
  styleUrls: ['./export-kpi.component.less']
})
export class ExportKpiComponent implements OnInit {

  moment = require('moment/moment');

  isSuperAdmin = false;
  deviceLoader: boolean = true;
  deviceId: string;
  date: { start: Moment, end: Moment };
  isDate: boolean;
  devicesSelector: Device[];
  ranges: any = {}

  constructor(public _searchService: SearchService,
    private readonly _toastService: ToastService,
    private readonly i18n: I18n
    ) {
      this.ranges[this.i18n({
        id: 'today',
        value: "Aujourd'hui",
        meaning: "export-kpi"
      })]  = [this.moment(), this.moment()];
      this.ranges[this.i18n({
        id: 'yesteray',
        value: "Hier",
        meaning: "export-kpi"
      })]  = [this.moment().subtract(1, 'days'), this.moment().subtract(1, 'days')];
      this.ranges[this.i18n({
        id: 'lastWeek',
        value: "Les 7 derniers jours",
        meaning: "export-kpi"
      })] = [this.moment().subtract(29, 'days'), this.moment()];
      this.ranges[this.i18n ({
        id: 'last30Days',
        value: "Les 30 derniers jours",
        meaning: "export-kpi"
      })] = [this.moment().subtract(29, 'days'), this.moment()];
      this.ranges[this.i18n ({
        id: 'thisMonth',
        value: 'Ce Mois',
        meaning: "export-kpi"
      })] = [this.moment().startOf('month'), this.moment().endOf('month')];
      this.ranges[this.i18n ({
        id: "lastMonth",
        value: "Le Mois dernier",
        meaning: "export-kpi"
      })] = [this.moment().subtract(1, 'month').startOf('month'), this.moment().subtract(1, 'month').endOf('month')];
    this.moment.locale('fr');
    this.isSuperAdmin = parse.User.current().get('isSuperAdmin');
    this.devicesSelector = [];
    this._searchService.getDevices().then(alldev => {
      alldev.forEach(device => {
        this.devicesSelector.push({ id: device.id, name: device.get('serialNumber') + ' ' +device.get('name')});
      });
    }).then(() => { 
      if (this.devicesSelector)
      this.devicesSelector.sort((a,b)=> {
        if(a.name < b.name) { return -1; }
        if(a.name > b.name) { return 1; }
        return 0;
      })
      this.deviceLoader = false; })
    
  }

  erasedate() { this.date = { start: null, end: null } }

  updateSearchDate(event: { start: Moment, end: Moment }) {
    if (!(event.start === null || event.end === null
      || event.start === undefined || event.end === undefined)) {
      this.date.start = event.start;
      this.date.end = event.end;
      this.isDate = true;
    } else {
      this.date = undefined;
      this.isDate = false;
    }
  }

  export() {
    if (this.date === undefined
      || this.date.start === null
      || this.date.start === undefined
      || this.date.end === null
      || this.date.end === undefined
      || this.deviceId === null
      || this.deviceId === ''
      || this.deviceId === undefined)
      this._toastService.toastOpen(undefined, this.i18n({
        id: 'emptyField',
        value: "Un champ est vide",
        description: "Un champ est vide",
        meaning: "export-kpi"
      }), "error");
    else if (this.isSuperAdmin) {
      this._toastService.toastOpen(true, 'Export');
      parse.Cloud.run("exportKPI", {
        dateStart: this.date.start.startOf('day').toDate(),
        dateEnd: this.date.end.endOf('day').toDate(),
        deviceId: this.deviceId
      }).then((data) => {
        this._toastService.toastOpen(false, 'Export');
        if (data) {
          let d = this.devicesSelector.find((device) => { return device.id === this.deviceId })
          new AngularCsv(data, `ExportKpi_name-${d.name}_id-${d.id}_date-${this.moment().format('L LTS')}`);
        } else
          this._toastService.toastOpen(undefined, this.i18n({
            id: 'noData',
            value: 'Error : no data into response',
            description: 'Error : no data into response',
            meaning: "contact"
          }), "error");
      }).catch((err) => {
        this._toastService.toastOpen(false, 'Export');
        this._toastService.toastOpen(undefined,  
          this.i18n({
            id: 'error',
            value: 'Error : ',
            description: 'Error : ',
            meaning: "contact"
          }), "error");
      })
    }
  }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// ./src/app/element/export-kpi/export-kpi.component.ts